import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { useAppDispatch } from 'store';

import { startTimer } from 'modules/blok-test';
import { $apiV2, globalConst } from 'modules/global';

import { IDTMResponse } from '../models';

export const useProgress = () => {
  const { push } = useRouter();
  const dispatch = useAppDispatch();

  const { data: startedTest, ...args } = useQuery<IDTMResponse>({
    queryKey: ['dtm-progress-test'],
    queryFn: async () => {
      const { data } = await $apiV2.get('/dtm/progress');

      return data.data;
    },
    refetchOnMount: true,
    onSuccess: data => {
      if (!data) {
        push(globalConst.pageNames.DTM);
      }
      dispatch(startTimer());
    },
    onError: () => {
      push(globalConst.pageNames.DTM);
    }
  });

  return { startedTest, ...args };
};
